import {
  SET_AMENITIES_TOTAL_RECORDS,
  SET_AMENITIES_PAGE,
  EDIT_AMENITIES,
  ADD_AMENITIES,
  DELETE_AMENITIES,
  AMENITIES_LOADING,
  AMENITIES_FAILURE,
  GET_AMENITIES,
  SET_AMENITIES_REDIRECT_URL,
  GET_ALL_AMENITIES
} from "./amenities-constant";
import {
  handleLoading,
  handleFailure,
  handleSetRedirectUrl,
  handleGetData,
  handleSetTotalRecords,
  handleSetPage,
  handleEditItem,
  handleAddItem,
  handleDeleteItems,
} from "../utils/reducerUtils";

// Initial state
const initialState = {
  amenitiesList: {},
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,
  redirectTo: false,
  allAmenities:[]
};

export const amenitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case AMENITIES_LOADING:
      return handleLoading(state, action);

    case AMENITIES_FAILURE:
      return handleFailure(state, action);

    case SET_AMENITIES_REDIRECT_URL:
      return handleSetRedirectUrl(state, action);

    case GET_AMENITIES:
      return handleGetData(state, action, "amenitiesList");

    case SET_AMENITIES_TOTAL_RECORDS:
      return handleSetTotalRecords(state, action);

    case SET_AMENITIES_PAGE:
      return handleSetPage(state, action);

    case EDIT_AMENITIES:
      return handleEditItem(state, action, "amenitiesList", "amenityId");

    case ADD_AMENITIES:
      return handleAddItem(state, action, "amenitiesList", "amenityId");

    case DELETE_AMENITIES:
      return handleDeleteItems(state, action, "amenitiesList", "amenityId");
    case GET_ALL_AMENITIES:
      return { ...state, allAmenities: action.payload };
    default:
      return state;
  }
};
